'use client';

import React from 'react';
import CasinoPartnerCard from '@/app/components/CasinoPartnerCard';
import { casinoPartners } from '@/app/lib/casinoPartners';

export default function Partners() {
    return (
        <div id="casinos" className="py-16 px-4">
            <h2 className="text-2xl md:text-4xl font-mono font-bold text-center mb-4 text-green-400">
                <span className="inline-block animate-pulse">{'['}</span> PARTNERS & SPONSORSHIPS <span className="inline-block animate-pulse">{']'}</span>
            </h2>
            <p className="text-center text-green-300 font-mono mb-12">
                Play & win with my code
            </p>

            <div className="max-w-6xl mx-auto space-y-6">
                {casinoPartners.map((casino, index) => (
                    <CasinoPartnerCard key={index} casino={casino} />
                ))}
            </div>
        </div>
    );
}
